var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('ToasterContainer'),(_vm.isSessionAvailable)?[_c('router-view'),_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container footer__wrapper"},[_c('span',{staticClass:"footer__text"},[_vm._v("© Audience Key - "+_vm._s(_vm.currentYear))])])])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }